import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  // base: '/dist',
  routes: [{
      path: '/',
      component: () => import('@/pages/index/index.vue'),
      meta: {
        title: '厦门云知学科技有限公司'
      }
    },
    {
      path: '/hardware',
      component: () => import('@/pages/hardware/hardware.vue'),
      meta: {
        title: '人脸识别一体机'
      }
    },
    {
      path: '/function',
      component: () => import('@/pages/function/function.vue'),
      meta: {
        title: '功能服务'
      }
    },
    {
      path: '/solution',
      component: () => import('@/pages/solution/solution.vue'),
      meta: {
        title: '校园进出解决方案'
      }
    },
    {
      path: '/case',
      component: () => import('@/pages/case/case.vue'),
      meta: {
        title: '学校案例'
      }
    },
    {
      path: '/caseShow',
      component: () => import('@/pages/case/caseShow.vue'),
      meta: {
        title: '学校案例'
      }
    },
    {
      path: '/about',
      component: () => import('@/pages/about/about.vue'),
      meta: {
        title: '关于云知学'
      }
    },
    {
      path: '/m_index',
      component: () => import('@/pages/index/m_index.vue'),
      meta: {
        title: '厦门云知学科技有限公司'
      }
    },
    {
      path: '/m_function',
      component: () => import('@/pages/function/m_function.vue'),
      meta: {
        title: '功能服务'
      }
    },
    {
      path: '/m_hardware',
      component: () => import('@/pages/hardware/m_hardware.vue'),
      meta: {
        title: '智能硬件'
      }
    },
    {
      path: '/m_solution',
      component: () => import('@/pages/solution/m_solution.vue'),
      meta: {
        title: '解决方案'
      }
    },
    {
      path: '/m_about',
      component: () => import('@/pages/about/m_about.vue'),
      meta: {
        title: '关于云知学'
      }
    },
    {
      path: '/m_case',
      component: () => import('@/pages/case/m_case.vue'),
      meta: {
        title: '学校案例'
      }
    },
    {
      path: '/m_case_video',
      component: () => import('@/pages/case/m_case_video.vue'),
      meta: {
        title: '学校案例-视频'
      }
    },
    {
      path: '/m_case_show',
      component: () => import('@/pages/case/m_case_show.vue'),
      meta: {
        title: '学校案例'
      }
    },
    {
      path: '/m_video_show',
      component: () => import('@/pages/case/m_video_show.vue'),
      meta: {
        title: '学校案例-视频'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js